module.exports = __webpack_public_path__ + "static/cratoni-logo-44026cd216e65a64dc286127a716efdc.png";